import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=66670f61&scoped=true"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=66670f61&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66670f61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66670f61')) {
      api.createRecord('66670f61', component.options)
    } else {
      api.reload('66670f61', component.options)
    }
    module.hot.accept("./transactionDetail.vue?vue&type=template&id=66670f61&scoped=true", function () {
      api.rerender('66670f61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/sub-merchant/components/content/payment-link/components/tabs/transactionDetail.vue"
export default component.exports